import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { MasterySection } from '../components/MasterySection';
import { BonusSection } from '../components/BonusSection';
import { ComboSection } from '../components/ComboSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { DifferentiatorsSection } from '../components/DifferentiatorsSection';
import { AudienceSection } from '../components/AudienceSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { SocialProofPopup } from '../components/SocialProofPopup';
export function LandingPage() {
  return <div className="flex flex-col w-full" data-id="element-306">
      <SocialProofPopup data-id="element-307" />
      <HeroSection data-id="element-308" />
      <ProblemSection data-id="element-309" />
      <SolutionSection data-id="element-310" />
      <MasterySection data-id="element-311" />
      <BonusSection data-id="element-312" />
      <ComboSection data-id="element-313" />
      <TestimonialsSection data-id="element-314" />
      <DifferentiatorsSection data-id="element-315" />
      <AudienceSection data-id="element-316" />
      <FAQSection data-id="element-317" />
      <FinalCTASection data-id="element-318" />
    </div>;
}